import React, { useRef, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api from "../api/index";
import { useAlert } from "react-alert";
import OtpInput from "react-otp-input";
import Modal from "react-bootstrap/Modal";
import { OtpModal } from "./otpModal";
import CountrySelect from "./countrySelect";
import { TextField } from "@mui/material";
import axios from "axios";
import showPassImg from "../images/showPass.svg";
import hidePass from "../images/hidePass.svg";
import "react-phone-number-input/style.css";
import PhoneInput, {
  formatPhoneNumber,
  formatPhoneNumberIntl,
  isValidPhoneNumber,
} from "react-phone-number-input";
import { useEffect } from "react";
import WAValidator from "multicoin-address-validator";
import { useDispatch } from "react-redux";
import userAction from "../redux/users/action";
import "./auth.css";

const currentYear = new Date().getFullYear();
const years = Array.from({ length: 100 }, (_, i) => currentYear - i);

export const Signup = ({ setSubsData }) => {
  const alert = useAlert();
  const dispatch = useDispatch();
  const { setUser } = userAction;

  const ref = useRef();
  const [searchParams] = useSearchParams();
  const sEmail = searchParams.get("email");

  const navigate = useNavigate();
  const [showPass, setShowPass] = useState(false);
  const [validAddress, setValidAddress] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [phoneNum, setPhoneNum] = useState("");
  const [data, setData] = useState({
    email: "",
    password: "",
    confirmPassword: "",
  });
  const [loader, setLoader] = useState(false);

  const register = async (e) => {
    e.preventDefault();
    setLoader(true);

    try {
      const validatorsResponse = await validators();

      if (validatorsResponse) {
        setLoader(false);
        return alert.show(validatorsResponse);
      }

      const payload = {
        email: data.email,
        name: data.name,
        password: data.password,
        // wallet: data.wallet,
        // country: data.country,
        // phone: phoneNum,
        // dob: `${data?.year}-${data?.month}-${data?.day}`,
        // gender: data.gender,
        termsAccepted: data.termsAccepted,
        // signature: data.signature,
      };
      // console.log(payload);
      const url = `${process.env.REACT_APP_SERVER_BASE_URL}/user/register`;

      axios
        .post(url, payload)
        .then((data) => {
          // console.log(data);

          // setShowModal(true);
          alert.show("Registered successfully.");
          // navigate("/login");
          login(payload?.email, payload?.password);
          // alert.show("Registered successfully, Please verify email");
          setLoader(false);
        })
        .catch((e) => {
          console.log(e);
          if (
            e.message == "server not responding" ||
            e.message == "Network Error"
          ) {
            alert.show("PLEASE TRY AGAIN SHORTLY...");
          } else {
            alert.show(e?.response?.data || "PLEASE TRY AGAIN SHORTLY...");
          }
          // alert.show("Invalid Credentials or Account not verified");
          setLoader(false);
        });
    } catch (e) {
      console.log(e);
      alert.show("PLEASE TRY AGAIN SHORTLY...");
      setLoader(false);
    }
  };

  const login = async (email, password) => {
    setLoader(true);

    try {
      const payload = {
        email,
        password,
      };
      const registerationResponse = await api.login(payload);
      // console.log(registerationResponse);

      axios.defaults.headers.common["Authorization"] =
        registerationResponse.token;

      const userId = registerationResponse?.user?._id;

      localStorage.setItem("token", registerationResponse.token);
      checkSubs(userId);
      dispatch(setUser(registerationResponse));
      navigate("/");
      setLoader(false);
    } catch (e) {
      console.log(e.toString());
      if (
        e.message == "server not responding" ||
        e.message == "Network Error"
      ) {
        alert.show("PLEASE TRY AGAIN SHORTLY...");
      } else {
        alert.show(e.message);
      }
      // alert.show("Invalid Credentials or Account not verified");
      setLoader(false);
    }
  };

  const checkSubs = async (userId) => {
    setLoader(true);
    // console.log("checksubs");

    const res = await api.checkSubscription(userId);
    // console.log(res);

    if (res?.subscription) {
      let currentDate = new Date();
      let endDate = new Date(res?.subscription?.nextPayment);
      if (currentDate < endDate) {
        res.subscription.isSubscription = true;
        setSubsData(res?.subscription);
      } else {
        res.subscription.isSubscription = false;
        setSubsData(res?.subscription);
      }
    }
    setLoader(false);
  };

  function hasWhiteSpace(s) {
    return /\s/g.test(s);
  }

  const STRENGTH_NAMES = ["", "Weak", "Fair", "Good", "Strong"];
  const passwordScore = (p) => {
    if (!p) return 0;
    let s = 0;
    if (p.length >= 8) s++;
    if (/[A-Z]/.test(p) && /[a-z]/.test(p)) s++;
    if (/[0-9]/.test(p)) s++;
    if (/[^A-Za-z0-9]/.test(p)) s++;
    return s;
  };
  const validators = () => {
    let regexEmail =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z]+)+$/;

    if (!data.name) {
      return "User name is required";
    }
    // if (hasWhiteSpace(data.name)) {
    //   return "Space are not allowed in username";
    // }
    if (!data.email) {
      return "Email is required";
    }
    // if (!data.phone) {
    //   return "Phone is required";
    // }
    // if (isNaN(data.phone)) {
    //   return "Phone is not correctly formatted";
    // }
    if (data.email && !regexEmail.test(data.email)) {
      return "Email is not correctly formatted";
    }
    // if (!data.wallet) {
    //   return "Wallet is required";
    // }
    // if (!validAddress) {
    //   return "Wallet address is invalid";
    // }
    // if (!data.gender) {
    //   return "Gender is required";
    // }
    // if (!data.day) {
    //   return "Day of birth is required";
    // }
    // if (data.day < 1 || data.day > 31) {
    //   return "Day must be greater than 1 and less than 31";
    // }
    // if (!data.month) {
    //   return "Month of birth is required";
    // }
    // if (!data.year) {
    //   return "Year of birth is required";
    // }
    // if (data.year < 1900) {
    //   return "Year must be greater than 1900";
    // }
    // if (!data.country) {
    //   return "Country is required";
    // }
    // if (!phoneNum) {
    //   return "Phone is required";
    // }
    // if (phoneNum.length > 15) {
    //   return "Phone must be less than 15 number";
    // }

    if (!data.password) {
      return "Password is required";
    }
    if (data.password && data.password.length < 8) {
      return "Password must be 8 characters long";
    }
    if (!data.confirmPassword) {
      return "Confirm password is required";
    }
    if (data.password !== data.confirmPassword) {
      return "Password and Confirm password not matched";
    }
    // if (!data?.signature) {
    //   return "Please add signature";
    // }
    // if (data?.signature.length > 30) {
    //   return "Max 30 character allowed in signature";
    // }
    if (!data?.termsAccepted) {
      return "Please read and  accept terms and conditions";
    }

    return false;
  };

  const onTextChange = (e, type) => {
    if (e.label) {
      setData({ ...data, country: e.label });
    } else if (e.target.name == "terms") {
      setData({ ...data, termsAccepted: e.target.checked });
    } else {
      setData({ ...data, [e.target.name]: e.target.value });
    }
  };

  // useEffect(() => {
  // if(data?.wallet) {
  //   let firstLetter = data?.wallet.slice(1);
  //   console.log(firstLetter);
  //   var valid = WAValidator.validate(data?.wallet, 'TRX');
  //     if(valid) {
  //       console.log('This is a valid address');
  //       setValidAddress(true)
  //     }
  //     else {
  //       console.log('Address INVALID');
  //       setValidAddress(false)
  //     }
  // }
  // }, [data?.wallet])

  useEffect(() => {
    if (sEmail) {
      setData({ ...data, email: sEmail });
    }
  }, [sEmail]);

  const pwScore = passwordScore(data.password);
  const pwMismatch =
    !!data.confirmPassword && data.confirmPassword !== data.password;

  return (
    <>
      <div className="wzAuthStage is-signup">
        <div className="wzAuth-orb o1"></div>
        <div className="wzAuth-orb o2"></div>

        <div className="wzAuth-frame">
          <form noValidate id="contactForm" className="wzAuth-card">
            <div className="wzAuth-head">
              <div className="wzAuth-badge">&#10022;</div>
              <h1>Create Your Account</h1>
              <p>Join the award-winning trading team.</p>
            </div>

            <div className="wzAuth-form">
              <div>
                <label className="wzAuth-label c-name" htmlFor="name">
                  Full Name
                </label>
                <div className="wzAuth-field">
                  <span className="ic">
                    <i className="fa-solid fa-user" />
                  </span>
                  <input
                    onChange={(e) => onTextChange(e)}
                    type="text"
                    name="name"
                    id="name"
                    required
                    placeholder="Your full name"
                    className="wzAuth-input"
                  />
                </div>
              </div>

              <div>
                <label className="wzAuth-label c-email" htmlFor="email">
                  Email
                </label>
                <div className="wzAuth-field">
                  <span className="ic">
                    <i className="fa-solid fa-envelope" />
                  </span>
                  <input
                    onChange={(e) => onTextChange(e)}
                    value={data?.email}
                    type="text"
                    name="email"
                    id="email"
                    required
                    disabled={sEmail ? true : false}
                    placeholder="you@example.com"
                    className="wzAuth-input"
                  />
                </div>
              </div>

              <div className="wzAuth-row">
                <div>
                  <label className="wzAuth-label c-pw" htmlFor="password">
                    Password
                  </label>
                  <div className="wzAuth-field pw">
                    <span className="ic">
                      <i className="fa-solid fa-lock" />
                    </span>
                    <input
                      onChange={(e) => onTextChange(e)}
                      type={showPass ? "text" : "password"}
                      name="password"
                      id="password"
                      required
                      placeholder="Password"
                      className="wzAuth-input"
                    />
                    <button
                      type="button"
                      className="wzAuth-eye"
                      aria-label="Toggle password visibility"
                      onClick={() => setShowPass(!showPass)}
                    >
                      {showPass ? (
                        <img src={showPassImg} alt="" />
                      ) : (
                        <img src={hidePass} alt="" />
                      )}
                    </button>
                  </div>
                </div>
                <div>
                  <label
                    className="wzAuth-label c-confirm"
                    htmlFor="confirmPassword"
                  >
                    Confirm
                  </label>
                  <div
                    className={
                      pwMismatch ? "wzAuth-field pw mismatch" : "wzAuth-field pw"
                    }
                  >
                    <span className="ic">
                      <i className="fa-solid fa-shield-halved" />
                    </span>
                    <input
                      onChange={(e) => onTextChange(e)}
                      type={showPass ? "text" : "password"}
                      name="confirmPassword"
                      id="confirmPassword"
                      required
                      placeholder="Confirm password"
                      className="wzAuth-input"
                    />
                    <button
                      type="button"
                      className="wzAuth-eye"
                      aria-label="Toggle confirm password visibility"
                      onClick={() => setShowPass(!showPass)}
                    >
                      {showPass ? (
                        <img src={showPassImg} alt="" />
                      ) : (
                        <img src={hidePass} alt="" />
                      )}
                    </button>
                  </div>
                </div>
              </div>

              <div className="wzAuth-strength">
                <div className="wzAuth-strength-meta">
                  <span className="k">Password strength</span>
                  <span className="v">
                    {pwMismatch
                      ? "Passwords do not match"
                      : STRENGTH_NAMES[pwScore] || "—"}
                  </span>
                </div>
                <div className="wzAuth-bars">
                  {[0, 1, 2, 3].map((i) => (
                    <i
                      key={i}
                      style={{
                        background:
                          i < pwScore
                            ? ["", "#ef4444", "#f59e0b", "#3b82f6", "#10b981"][
                                pwScore
                              ]
                            : undefined,
                      }}
                    />
                  ))}
                </div>
              </div>

              <label
                className={
                  data?.termsAccepted ? "wzAuth-terms is-on" : "wzAuth-terms"
                }
              >
                <input
                  type="checkbox"
                  name="terms"
                  checked={!!data?.termsAccepted}
                  onChange={(e) => onTextChange(e)}
                />
                <span className="wzAuth-box">
                  <span>&#10003;</span>
                </span>
                <span className="txt">
                  I have read and agree to the{" "}
                  <a href="/terms-and-conditions" target="_blank" rel="noreferrer">
                    Terms & Conditions
                  </a>
                </span>
              </label>

              {loader ? (
                <button type="button" className="wzAuth-submit" disabled>
                  <span className="wzAuth-shine"></span>
                  <span className="label">
                    <i
                      className="fa fa-spinner fa-pulse me-2"
                      style={{ position: "relative", top: "-0px" }}
                    ></i>
                    Creating account...
                  </span>
                </button>
              ) : (
                <button
                  onClick={register}
                  type="submit"
                  className="wzAuth-submit"
                  disabled={!data?.termsAccepted}
                >
                  <span className="wzAuth-shine"></span>
                  <span className="label">
                    {data?.termsAccepted
                      ? "Create Account"
                      : "Accept the terms to continue"}
                  </span>
                </button>
              )}

              <p className="wzAuth-foot">
                Already have an account?{" "}
                <Link to={"/login"}>
                  Log in
                </Link>
              </p>
            </div>
          </form>
        </div>
      </div>
      <OtpModal show={showModal} setShow={setShowModal} email={data.email} />
    </>
  );
};
